import { render, staticRenderFns } from "./OtherActions.vue?vue&type=template&id=22a23f51&scoped=true&"
import script from "./OtherActions.vue?vue&type=script&lang=js&"
export * from "./OtherActions.vue?vue&type=script&lang=js&"
import style0 from "./OtherActions.vue?vue&type=style&index=0&id=22a23f51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a23f51",
  null
  
)

export default component.exports